import { sportingAPI } from 'services/sporting/api';

export const getNewReviewsCount = async (): Promise<number> => {
  const reviews = await sportingAPI.service.getNewCommentsCount();

  return reviews.length;
};
